/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useLocation } from "react-router-dom"
import { useParams} from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import {
  TRAVELER_DETAILS_JOIN_ROUTE,
  TRAVELER_DETAILS_ROUTE
} from "../../constants/routes";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useHasPermission } from "../../hooks/useHasPermission";
import { useUserContext } from "../../contexts/userContext";
import { AIRLINES } from "../../constants/appConstants";

/* Components */
import ProfileTab from "./profileTab";
import JoinTab from "./joinTab"
import UCSelect from "../ucselect";

/* Styles */
import styles, {tabsSelectOpen} from "./styles.js"

const tabOptions = [
  { value: 'profile', label: <FormattedMessage id="traveler.profile" /> },
]

const TravelerDetailsTabbedNav = ({travelerDetails, refetchTravelerDetails}) => {

  const location = useLocation();
  
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { checkPermission } = useHasPermission();
  let { travelerId } = useParams();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const [defaultPage, setDefaultPage] = useState("profile");

  useEffect(() => {
    setDefaultPage(getDefaultPage())
  }, [location.pathname]);

  const getDefaultPage = () => {
    if(location.pathname.includes(TRAVELER_DETAILS_JOIN_ROUTE.replace(":travelerId", travelerId))) return "join"
    if(location.pathname.includes(TRAVELER_DETAILS_ROUTE.replace(":travelerId", travelerId))) return "profile"
  }

  const getDefaultLabel = () => {
    if(location.pathname.includes(TRAVELER_DETAILS_JOIN_ROUTE.replace(":travelerId", travelerId))) return <FormattedMessage id="join.title"/>
    if(location.pathname.includes(TRAVELER_DETAILS_ROUTE.replace(":travelerId", travelerId))) return <FormattedMessage id="traveler.profile"/>
  }

  const handleTabChange = nextTab => {
    switch(nextTab) {
      case "profile":
        navigate('../' + TRAVELER_DETAILS_ROUTE.replace(":travelerId", travelerDetails?.userEntityId));
      break;
      case "join":
        navigate('../' + TRAVELER_DETAILS_JOIN_ROUTE.replace(":travelerId", travelerDetails?.userEntityId))
      break;
    }
  }

  const viewTab = tab => {
    switch(tab) {
      case "profile":
        return <ProfileTab travelerDetails={travelerDetails} refetchTravelerDetails={refetchTravelerDetails}/>
      case "join":
        return <JoinTab userId={travelerDetails?.userEntityId}/>
    }
  }

  return (
    <div className={classes.travelerTabbedNav}>
      {isMobile ? (
        <>
          <UCSelect
            styles={{ ...tabsSelectOpen }}
            defaultValue={{ 
              value: defaultPage || getDefaultPage(), 
              label: getDefaultLabel()
            }}
            value={defaultPage || getDefaultPage()}
            options={[
              ...tabOptions,
              ...(checkPermission("F_VIEW_USERDASHBOARD_AVAILABLEPROVIDERS") && providerCode === AIRLINES.UC ? [{ value: 'join', label: <FormattedMessage id="join.title" />}] : [])
            ]}
            onChange={(tab) => handleTabChange(tab.value)}
          />
          {viewTab(defaultPage || getDefaultPage())}
        </>
      ) : (
      <Tabs
        onSelect={nextTab => handleTabChange(nextTab)}
        defaultActiveKey={ getDefaultPage() }
        activeKey={defaultPage}
        id="traveler-details-page-tabs"
        className={ classes.tabs }
      >
        <Tab eventKey="profile" title={<FormattedMessage id="traveler.profile" />}>
        { getDefaultPage() === "profile" && <ProfileTab travelerDetails={travelerDetails} refetchTravelerDetails={refetchTravelerDetails}/>}
        </Tab>
        {
          checkPermission("F_VIEW_USERDASHBOARD_AVAILABLEPROVIDERS") && providerCode === AIRLINES.UC &&
          <Tab eventKey="join" title={<FormattedMessage id="join.title" />}>
          { getDefaultPage() === "join" && <JoinTab userId={travelerDetails?.userEntityId}/>}
          </Tab>
        }
      </Tabs>
      )}
    </div>
  )
}

export default TravelerDetailsTabbedNav;
